const C = (approver) => ({ confirmed: true, approver });
const R = { confirmed: false };

export const SCENARIOS = [
  {
    id: 'hvac', tab: 'HVAC', title: 'AC Repair Visit', caller: 'New HVAC Customer',
    fields: [['Issue', 'Blowing Warm Air Upstairs'], ['Property Type', 'Single-Family Home']],
    time: 'Thursday · Morning Window', ...C('Office Manager'),
    message: 'Your AC repair visit is confirmed for Thursday morning. Reply here if anything changes.',
    alert: 'AC Repair Visit Confirmed For Thursday Morning',
  },
  {
    id: 'plumbing', tab: 'Plumbing', title: 'Leaking Sink Service Request', caller: 'New Plumbing Customer',
    fields: [['Issue', 'Kitchen Sink Leaking Under Cabinet'], ['Property Type', 'Condo']],
    time: 'Tomorrow · Afternoon', ...R,
    message: 'Thanks, we received your request for tomorrow afternoon. Our team will confirm the time with you.',
    alert: 'Sink Leak Request Awaiting Your Confirmation',
  },
  {
    id: 'roofing', tab: 'Roofing', title: 'Roof Inspection Request', caller: 'New Roofing Customer',
    fields: [['Concern', 'Missing Shingles After A Storm'], ['Property Type', 'Two-Story Home']],
    time: 'Monday · Morning', ...R,
    message: 'Thanks, we received your roof inspection request for Monday morning. Our team will confirm the visit with you.',
    alert: 'Roof Inspection Request Awaiting Your Confirmation',
  },
  {
    id: 'dental', tab: 'Dental', title: 'New Patient Appointment Request', caller: 'New Patient',
    fields: [['Appointment Type', 'New Patient Exam & Cleaning'], ['Patient Status', 'First Visit']],
    time: 'Wednesday · 9:00 AM', ...C('Front Desk'),
    message: 'Your new patient appointment is confirmed for Wednesday at 9:00 AM. Reply here if you need to reschedule.',
    alert: 'New Patient Appointment Confirmed For Wednesday',
  },
  {
    id: 'medspa', tab: 'Med Spas', title: 'Consultation Request', caller: 'New Client',
    fields: [['Appointment Type', 'Skin Consultation'], ['Client Status', 'First Visit']],
    time: 'Friday · Afternoon', ...R,
    message: 'Thanks, we received your consultation request for Friday afternoon. Our team will confirm the time with you.',
    alert: 'Consultation Request Awaiting Your Confirmation',
  },
  {
    id: 'junk', tab: 'Junk Removal', title: 'Garage Cleanout Estimate', caller: 'New Junk Removal Customer',
    fields: [['Items To Remove', 'Old Furniture, Boxes, Shelving'], ['Access', 'Ground-Level Garage']],
    time: 'Saturday · Morning Estimate Visit', ...C('Dispatcher'),
    message: 'Your garage cleanout estimate visit is confirmed for Saturday morning. Reply here if anything changes.',
    alert: 'Garage Cleanout Estimate Confirmed For Saturday',
  },
  {
    id: 'cleaning', tab: 'Cleaning', title: 'Recurring Home Cleaning Quote', caller: 'New Cleaning Customer',
    fields: [['Cleaning Frequency', 'Every Two Weeks'], ['Home Size', '3 Bedrooms, 2 Bathrooms']],
    time: 'Start Next Tuesday · Quote Requested', ...R,
    message: 'Thanks, we received your recurring cleaning quote request. Our team will review it and follow up with you.',
    alert: 'Recurring Cleaning Quote Request Awaiting Review',
  },
  {
    id: 'auto', tab: 'Auto Services', title: 'Brake Inspection Request', caller: 'New Auto Service Customer',
    fields: [['Vehicle', '2018 Sedan'], ['Concern', 'Squeaking When Braking']],
    time: 'Thursday · 8:00 AM Drop-Off', ...C('Service Advisor'),
    message: 'Your brake inspection is confirmed for Thursday at 8:00 AM drop-off. Reply here if anything changes.',
    alert: 'Brake Inspection Confirmed For Thursday',
  },
];

export const stageLabels = (s) => [
  'Incoming Call',
  'Customer Details Captured',
  s.confirmed ? 'Appointment Confirmed' : 'Appointment Requested',
  s.confirmed ? 'Confirmation Sent' : 'Request Received Text Sent',
  'Team Notified',
];
